// console.log('resources/assets/js/modules/user_status.js');
/*
|-------------------------------------------------------------------------------
| VUEX modules/UserStatus.js
|-------------------------------------------------------------------------------
| The Vuex data store for the UserStatus
*/

import UserStatusAPI from '../api/user_status.js';

export const userStatus = {
	/*
    Defines the state being monitored for the module.
  */
	state: {
		UserStatus: {
			entity_title: '',
			user_role: [],
			permissions: []
		},
		UserStatusLoadStatus: 0,
		UserEditStatus: 0,
		UserEditText: ''
	},

	/*
    Defines the actions used to retrieve the data.
  */
	actions: {
		/*
      Loads the UserStatus from the API
    */
		loadUserStatus({ commit }) {
			// console.log('#### LOADING USER STATUS!! ####');
			commit('setUserStatusLoadStatus', 1);

			return UserStatusAPI.getUserStatus()
				.then(function (response) {
					commit('setUserStatus', response.data);
					commit('setUserStatusLoadStatus', 2);
					// console.log('#### DONE LOADING USER STATUS!! ####');
				})
				.catch(function () {
					commit('setUserStatus', []);
					commit('setUserStatusLoadStatus', 3);
				});
		},
		editUser({ commit, state, dispatch }, data) {
			commit('setUserEditStatus', 1);
			console.log('USER DATA: ');
			console.log(data);
			UserStatusAPI.putEditUser(data)
				.then(function (response) {
					console.log('USER EDIT RESPONSE: ');
					console.log(response);
					commit('setUserEditText', response.data.full_name + ' has been successfully updated!');
					commit('setUserEditStatus', 2);
					dispatch('loadUserStatus');
				})
				.catch(function (error) {
					console.log('USER EDIT ERROR: ');
					console.log(error);
					commit('setUserEditStatus', 3);
					dispatch('loadUserStatus');
				});
		}
	},

	/*
    Defines the mutations used
  */
	mutations: {
		setUserStatusLoadStatus(state, status) {
			state.UserStatusLoadStatus = status;
		},

		setUserStatus(state, UserStatus) {
			if (UserStatus.entity === null) {
				UserStatus.entity_title = 'newbie';
			} else {
				UserStatus.entity_title = UserStatus.entity.title;
			}
			state.UserStatus = UserStatus;
		},

		setUserEditStatus(state, status) {
			state.UserEditStatus = status;
		},

		setUserEditText(state, text) {
			state.UserEditText = text;
		}
	},

	/*
    Defines the getters used by the module
  */
	getters: {
		getUserStatusLoadStatus(state) {
			return state.UserStatusLoadStatus;
		},
		getUserEditStatus(state) {
			return state.UserEditStatus;
		},
		getUserEditText(state) {
			return state.UserEditText;
		},
		getUserStatus(state) {
			return state.UserStatus;
		},
		userCan: state => permission => {
			if (state.UserStatus.user_role.map(a => a.toLowerCase()).includes('administrator')) {
				return true;
			} else {
				var permissionGranted = state.UserStatus.permissions
					.map(a => a.toLowerCase())
					.includes(permission.toLowerCase());
				// if (!permissionGranted) {
				// 	console.warn('Permission to ' + permission + ' denied!');
				// }
				return permissionGranted;
			}
		}
	}
};
